import productSorter from '../components/product-sorting'

export default {
	namespace: 'productList',
	beforeEnter() {
		window.productSorter = productSorter()
	},
	afterEnter() {
		console.log('View: productList')

		// remove any active page overlays on load
		if (document.getElementsByClassName('site-overlay')[0].classList.contains('active')) {
			window.dispatchEvent(new CustomEvent('toggleoverlay'))
		}
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
